import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api, setAuth } from '../api/client'

export default function LoginPage() {
  const navigate = useNavigate()
  const [isRegister, setIsRegister] = useState(false)
  const [phone, setPhone] = useState('')
  const [pin, setPin] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const submit = async () => {
    setError('')
    if (!/^\d{8,20}$/.test(phone)) {
      setError('手機號碼要填 8~20 位數字喔')
      return
    }
    if (!/^\d{4}$/.test(pin)) {
      setError('密碼要填 4 位數字喔')
      return
    }
    setLoading(true)
    try {
      const data = await api(isRegister ? '/register' : '/login', {
        method: 'POST',
        body: { phone_number: phone, pin_code: pin },
      })
      setAuth(data.token, data.user_id)
      navigate('/records', { replace: true })
    } catch (e) {
      setError(e.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="flex min-h-[90vh] flex-col items-center justify-center gap-4">
      <div className="text-center">
        <div className="text-5xl">📒</div>
        <h1 className="mt-2 text-3xl font-bold text-white">老人腹膜健康記錄手冊</h1>
        <p className="mt-1 text-xl text-gray-300">用講的、用點的，輕鬆記錄每一天</p>
      </div>

      <div className="w-full max-w-md space-y-4 rounded-3xl bg-white p-6 shadow-2xl">
        <div>
          <label className="mb-1 block text-xl font-bold text-navy-900">手機號碼</label>
          <input
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value.replace(/\D/g, ''))}
            placeholder="例如 0912345678"
            className="h-14 w-full rounded-xl border-2 border-navy-700 px-3 text-2xl font-bold text-navy-900 focus:border-warn focus:outline-none"
          />
        </div>
        <div>
          <label className="mb-1 block text-xl font-bold text-navy-900">4 位密碼</label>
          <input
            type="password"
            value={pin}
            onChange={(e) => setPin(e.target.value.replace(/\D/g, ''))}
            placeholder="例如 1234"
            maxLength={4}
            className="h-14 w-full rounded-xl border-2 border-navy-700 px-3 text-2xl font-bold text-navy-900 focus:border-warn focus:outline-none"
          />
        </div>

        {error && (
          <p className="rounded-xl bg-red-100 p-2 text-center text-xl font-bold text-warn">⚠️ {error}</p>
        )}

        <button
          type="button"
          onClick={submit}
          disabled={loading}
          className="big-btn bg-safe text-white hover:bg-green-600 disabled:opacity-50"
        >
          {loading ? '處理中…' : isRegister ? '註冊並進入' : '進入系統'}
        </button>
        <button
          type="button"
          onClick={() => {
            setIsRegister(!isRegister)
            setError('')
          }}
          className="w-full text-center text-xl font-bold text-navy-700 underline"
        >
          {isRegister ? '已經有帳號？改用登入' : '還沒有帳號？註冊一個'}
        </button>
      </div>
    </div>
  )
}
